import Resizer from "react-image-file-resizer";

const MAX_SIZE = 120 * 1024;
const MIN_QUALITY = 10;

export const compressImageFile = (file, quality = 90, originalSize = file?.size) =>
    new Promise((resolve, reject) => {
        if (!file) {
            reject(new Error("No image selected"));
            return;
        }
        Resizer.imageFileResizer(
            file,
            1280,
            1280,
            "WEBP",
            quality,
            0,
            async (compressedFile) => {
                if (compressedFile.size <= MAX_SIZE || quality <= MIN_QUALITY) {
                    resolve(compressedFile);
                    return;
                }
                try {
                    resolve(await compressImageFile(compressedFile, quality - 10, originalSize));
                } catch (err) {
                    reject(err);
                }
            },
            "file"
        );
    });
